export enum MixPanelEvents {
  AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS',
  AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE',
  LOGOUT = 'LOGOUT',
  SCREEN = 'SCREEN',
  PARTNER_CHANGE = 'PARTNER_CHANGE',
  MONITOR_TIME_RANGE_SELECT = 'MONITOR_TIME_RANGE_SELECT',
  MONITOR_DOWNLOAD = 'MONITOR_DOWNLOAD',
  MONITOR_DELETE = 'MONITOR_DELETE',
  MONITOR_EDIT = 'MONITOR_EDIT',
  MONITOR_ADD = 'MONITOR_ADD',
  MONITOR_EDIT_SUCCESS = 'MONITOR_EDIT_SUCCESS',
  MONITOR_EDIT_FAILURE = 'MONITOR_EDIT_FAILURE',
  MONITOR_ADD_SUCCESS = 'MONITOR_ADD_SUCCESS',
  MONITOR_ADD_FAILURE = 'MONITOR_ADD_FAILURE',
  HEALTH_SUMMARY_TIME_RANGE = 'HEALTH_SUMMARY_TIME_RANGE',
  HEALTH_SUMMARY_ISSUE_CATEGORY = 'HEALTH_SUMMARY_ISSUE_CATEGORY',
  HEALTH_SUMMARY_ISSUE_DATE = 'HEALTH_SUMMARY_ISSUE_DATE',
  HEALTH_SUMMARY_DOWNLOAD = 'HEALTH_SUMMARY_DOWNLOAD',
  HEALTH_SUMMARY_EXPAND_ISP_SCORES = 'HEALTH_SUMMARY_EXPAND_ISP_SCORES',
  HEALTH_SUMMARY_EDXPAND_ISSUE_MATRIX = 'HEALTH_SUMMARY_EXPAND_ISSUE_MATRIX',
  OUTREACH_CONFIG_SUBSCRIBER_CREATE_SUCCESS = 'OUTREACH_CONFIG_SUBSCRIBER_CREATE_SUCCESS',
  OUTREACH_CONFIG_SUBSCRIBER_CREATE_FAILURE = 'OUTREACH_CONFIG_SUBSCRIBER_CREATE_FAILURE',
  OUTREACH_CONFIG_SUPPORT_CREATE_SUCCESS = 'OUTREACH_CONFIG_SUPPORT_CREATE_SUCCESS',
  OUTREACH_CONFIG_SUPPORT_CREATE_FAILURE = 'OUTREACH_CONFIG_SUPPORT_CREATE_FAILURE',
  OUTREACH_CONFIG_SUBSCRIBER_UPDATE_SUCCESS = 'OUTREACH_CONFIG_SUBSCRIBER_UPDATE_SUCCESS',
  OUTREACH_CONFIG_SUBSCRIBER_UPDATE_FAILURE = 'OUTREACH_CONFIG_SUBSCRIBER_UPDATE_FAILURE',
  OUTREACH_CONFIG_SUPPORT_UPDATE_SUCCESS = 'OUTREACH_CONFIG_SUPPORT_UPDATE_SUCCESS',
  OUTREACH_CONFIG_SUPPORT_UPDATE_FAILURE = 'OUTREACH_CONFIG_SUPPORT_UPDATE_FAILURE',
  OUTREACH_CONFIG_RETRIEVE_FAILURE = 'OUTREACH_CONFIG_RETRIEVE_FAILURE',
  OUTREACH_TEST_NOTIFICATION_MODAL_OPEN = 'OUTREACH_TEST_NOTIFICATION_MODAL_OPEN',
  WEBHOOK_SUCCESS = 'WEBHOOK_SUCCESS',
  WEBHOOK_FAILURE = 'WEBHOOK_FAILURE',
  EMAIL_SUCCESS = 'EMAIL_SUCCESS',
  EMAIL_FAILURE = 'EMAIL_FAILURE',
  URL_SUCCESS = 'URL_SUCCESS',
  URL_FAILURE = 'URL_FAILURE',
  INFO_MODAL_OPEN = 'INFO_MODAL_OPEN',
  OUTREACH_EVENTS_MODAL_OPEN = 'OUTREACH_EVENTS_MODAL_OPEN',
  HEALTH_SUMMARY_ISSUE_MATRIX_CATEGORY_SELECT = 'HEALTH_SUMMARY_ISSUE_MATRIX_CATEGORY_SELECT',
  FEEDBACK = 'FEEDBACK',
  REORDER_MONITORS = 'REORDER_MONITORS',
}
